import React from 'react';
import PieChart from './pie-chart';

const sortValues = (values) => {
  values.sort((a, b) => b[0] - a[0]);
  return values;
};

const LikelihoodModel = (props) => (
  <PieChart
    {...props}
    sortValues={sortValues}
    chartVariantClassName="pie-chart likelihood-model"
  />
);

export default LikelihoodModel;
